import { ScreenAttributes } from 'core/flow/entities';
import { AnimationsPreloader } from './AnimationsPreloader';
import { ImagesPreloader } from './ImagesPreloader';
import { ScreenPreloader } from './ScreenPreloader';
import { useNextScreensAttributes } from './useNextScreensAttributes';

type DynamicPreloadersProps = {
  screenId: string;
  initialScreenId: string;
  screenAttributes: ScreenAttributes;
  nextScreenAttributes: ScreenAttributes | null;
};

export const DynamicPreloaders = ({
  screenId,
  initialScreenId,
  screenAttributes,
  nextScreenAttributes,
}: DynamicPreloadersProps) => {
  const isInitialScreen = initialScreenId === screenId;
  const nextScreensAttributes = useNextScreensAttributes(screenAttributes.next);

  return (
    <>
      <ScreenPreloader
        isInitialScreen={isInitialScreen}
        screenType={screenAttributes.screenType}
        nextScreenType={nextScreenAttributes ? nextScreenAttributes.screenType : null}
      />
      <ImagesPreloader attributes={nextScreensAttributes} />
      <AnimationsPreloader attributes={nextScreensAttributes} />
    </>
  );
};
